export default {
  title: {
    en: 'Choose the value of your gift',
  },
  hint: {
    en: 'Use for any subscription, giftset purchase or just about anything on Scentbird',
  },
}
